import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Dropdown, TextInput } from "hesus-ui-kit";
import { updateUnitTranslation } from "@utils/utils";
import {
  GridRow,
  OptionLabel,
  SectionContainer,
} from "../AddEditSolution.styled";

import { country } from "@utils/constants";

const TreatmentOnly = (props) => {
  const {
    data,
    currencies,
    onTreatmentPriceChange,
    onTreatmentCurrencySelect,
    onTreatmentUnitSelect,
    onTGAPChange,
    onPollutionCommentChange,
    countryId,
    t,
    unitList,
    enquirySubCategoryId,
  } = props;

  return (
    <SectionContainer>
      <OptionLabel>{t("TREATMENT_ONLY")}</OptionLabel>
      <GridRow>
        <TextInput
          type="text"
          label={t("TREATMENT_PRICE")}
          name="treatment-price"
          id="treatment-price"
          isFloat
          value={String(data.treatmentPrice)}
          onChange={onTreatmentPriceChange}
          containerStyles={{ marginTop: "1.32rem" }}
          inputStyles={{ padding: "0.43rem 0.32rem 0.43rem 0.625rem" }}
        />
        <Dropdown
          label={t("MATCHING_TREATMENT_PRICE_CURRENCY")}
          name="currency"
          value={String(data.treatmentCurrency.value)}
          defaultOption={t("SELECT_CURRENCY")}
          containerStyles={{ marginBottom: "1.32rem" }}
          inputStyles={{ border: "1px solid #474747" }}
          options={currencies}
          error={data.treatmentCurrency.error}
          required
          onChange={onTreatmentCurrencySelect}
        />
        <Dropdown
          label={t("UNIT")}
          name="solution-dropdown-unit"
          value={String(data.treatmentUnit)}
          defaultOption={t("NONE_SELECTED")}
          containerStyles={{ marginBottom: "1.32rem" }}
          inputStyles={{ border: "1px solid #474747" }}
          options={updateUnitTranslation(unitList, t)}
          onChange={onTreatmentUnitSelect}
        />
      </GridRow>
      {parseInt(enquirySubCategoryId, 10) === 1 && (
        <div style={{ width: "66%" }}>
          <TextInput
            type="text"
            label={t("TGAP")}
            name="tgap"
            id="tgap"
            value={data.tgap ? String(data.tgap) : ""}
            onChange={onTGAPChange}
          />
        </div>
      )}
      {parseInt(enquirySubCategoryId, 10) === 1 && (
        <div style={{ margin: "1.32rem 0" }}>
          <TextInput
            type="textarea"
            label={t("CONCERNED_POLLUTION")}
            id="pollution_comment"
            name="pollution_comment"
            value={data.pollutionComment.value}
            required={countryId === country.France}
            error={
              countryId === country.France ? data.pollutionComment.error : ""
            }
            onChange={onPollutionCommentChange}
            inputStyles={{ height: "4rem" }}
          />
        </div>
      )}
    </SectionContainer>
  );
};

TreatmentOnly.propTypes = {
  countryId: PropTypes.number.isRequired,
  data: PropTypes.shape({
    treatmentPrice: PropTypes.string,
    treatmentUnit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    treatmentCurrency: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    tgap: PropTypes.string,
    pollutionComment: PropTypes.shape({
      value: PropTypes.string,
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
  }).isRequired,
  currencies: PropTypes.arrayOf(PropTypes.object).isRequired,
  onTreatmentPriceChange: PropTypes.func.isRequired,
  onTreatmentCurrencySelect: PropTypes.func.isRequired,
  onTreatmentUnitSelect: PropTypes.func.isRequired,
  onTGAPChange: PropTypes.func.isRequired,
  onPollutionCommentChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  enquirySubCategoryId: PropTypes.string,
};
TreatmentOnly.defaultProps = {
  enquirySubCategoryId: null,
};

export default withTranslation()(TreatmentOnly);
